import axios from '@/api/axios';
import { File } from '@/interface/components';
import * as c_Interface from '@/interface/components/profile';

export const getUser = (userId: string) => axios.get(`/users/${userId}`);
export const deleteUser = (userId: string) => axios.delete(`/users/${userId}`);
export const updateUser = (userId: string, payload: c_Interface.ChangeProfilePayload) =>
  axios.put(`/users/${userId}`, payload);

export const getAvatar = (userId: string) => axios.get(`/users/${userId}/avatar`);
export const signAvatar = (userId: string, payload: { imagePath: string }) =>
  axios.post(`/users/${userId}/avatar/sign`, payload);
export const signResultPut = (url: string, file: File) =>
  axios.put(url, file, { headers: { 'Content-Type': file.type } });
export const setAvatar = (userId: string, payload: { name: string; url: string }) =>
  axios.post(`/users/${userId}/avatar`, payload);
export const deleteAvatar = (userId: string) => axios.delete(`/users/${userId}/avatar`);

export const updatePassword = (userId: string, payload: c_Interface.ChangePasswordPayload) =>
  axios.put(`/users/${userId}/password`, payload);

export const getCreditCards = (userId: string) => axios.get(`/users/${userId}/credit-cards`);
export const getCreditCard = (userId: string, creditCardId: string) =>
  axios.get(`/users/${userId}/credit-cards/${creditCardId}`);
export const setCreditCard = (userId: string, payload: any) =>
  axios.post(`/users/${userId}/credit-cards`, payload);
export const updateCreditCard = (userId: string, creditCardId: string, payload: any) =>
  axios.put(`/users/${userId}/credit-cards/${creditCardId}`, payload);
export const deleteCreditCard = (userId: string, creditCardId: string) =>
  axios.delete(`/users/${userId}/credit-cards/${creditCardId}`);

export const updateAlarm = (userId: string, payload: c_Interface.SetEmailAlarmPayload) =>
  axios.put(`/users/${userId}/email-settings`, payload);
